function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/no-use-before-define */
import parseDataUrl from 'parse-data-url';
export function combine(vars, httpEnvHeader) {
  if (httpEnvHeader) {
    var httpEnv = decodeHttpEnvHeader(httpEnvHeader);
    return _objectSpread(_objectSpread({}, vars), httpEnv);
  }
  return _objectSpread({}, vars);
}
function decodeHttpEnvHeader(header) {
  if (header.startsWith('data:')) {
    var parsed = parseDataUrl(header);
    if (parsed && parsed.contentType === 'application/json') {
      var data = parsed.toBuffer().toString('utf-8');
      return decodeJson(data);
    }
    return {}; // unsupported data-uri
  }
  return decodeJson(header);
}
function decodeJson(json) {
  try {
    var decoded = JSON.parse(json);
    if (decoded && typeof decoded === 'object') {
      return decoded;
    }
  } catch (_unused) {
    // passthru
  }
  return {};
}